const academia = {
  createAcademia: 'academia',
  createAcademiaAutoresponder: 'academia/{{uuid_academia}}/autoresponder',
  createAcademiaPasarela: 'academia/{{uuid_academia}}/pasarela-pago',
  createAcademiaUsuario: 'academia/{{uuid_academia}}/actor',
  deleteAcademiaAutoresponder: 'academia/{{uuid_academia}}/autoresponder/{{id}}', /**/
  readAcademiaUsuariosExportar: 'academia/{{uuid_academia}}/usuarios/exportar',
  readAcademia: 'academia/{{uuid_academia}}',
  readAcademias: 'academias',
  readAcademiaAutoresponders: 'academia/{{uuid_academia}}/autoresponder',
  readAcademiaAutoresponderListas: 'academia/{{uuid_academia}}/autoresponder/{{id}}/listas', /**/
  readAcademiaAutorespondersParametros: 'autoresponder/{{id_autoresponder}}/campos-parametros/{{uuid_academia}}',
  readAcademiaCategorias: 'academia/categorias',
  readAcademiaDatos: 'academia/{{uuid_academia}}',
  readAcademiaInvitacionesPendiente: 'invitaciones/{{uuid_academia}}',
  readAcademiaLegales: 'academia/{{uuid_academia}}/legales',
  readAcademiaPasarelasConfiguradas: 'academia/{{uuid_academia}}/pasarelas-pago',
  readAcademiaPasarelasPorDivisa: 'academia/{{uuid_academia}}/pasarelas-pago/activas/{{divisa}}', /**/
  readAcademiaPerfilActor: 'academia/{{uuid_academia}}/perfil-usuario/{{uuid_actor}}',
  readAcademiaRecursosUsados: 'academia/{{uuid_academia}}/recursos-usados',
  readAcademiaUsuarios: 'academia/{{uuid_academia}}/usuarios',
  readAcademiaUsuarioActores: 'academia/{{uuid_academia}}/actores',
  readAcademiaValidUrl: 'academia/{{uuid_academia}}/validar-url/{{url}}',
  reenviarInvitacionPendiente: 'invitacion/{{uuid_invitacion}}/reenviar',
  createAcademiaActorResetPassword: 'academia/{{uuid_academia}}/actor/{{uuid_actor}}/reset-password',
  updateAcademia: 'academia/{{uuid_academia}}',
  updateAcademiaActorEstado: 'academia/{{uuid_academia}}/actor/{{uuid_actor}}/estado',
  updateAcademiaDatosPersona: 'academia/{{uuid_academia}}/persona',
  updateAcademiaLegales: 'academia/{{uuid_academia}}/legales',
  updateAcademiaPasarela: 'academia/{{uuid_academia}}/pasarela-pago/{{id_pasarela}}/editar',
  updateAcademiaPasarelaEstado: 'academia/{{uuid_academia}}/pasarela-pago/{{estado}}'
}

export default academia
